// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"6c5423af","530":"69a8948e"}[chunkId] + ".chunk.css";
};